import { render, staticRenderFns } from "./GlobalButtonPrimary.vue?vue&type=template&id=6cb3f7a9"
import script from "./GlobalButtonPrimary.vue?vue&type=script&lang=js"
export * from "./GlobalButtonPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports